import { useTranslation } from 'react-i18next'
import type { SiteDocStatus } from '@symphenia/shared-types'

const KLASSE: Record<SiteDocStatus, string> = {
  DRAFT: 'bg-muted text-foreground',
  AWAITING: 'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-100',
  FINAL: 'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-100',
  DECLINED: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-100',
  VOIDED: 'bg-red-100 text-red-900 dark:bg-red-900/40 dark:text-red-100',
  DISCARDED: 'bg-muted text-muted-foreground',
}

/** Zustand eines Baustellendokuments als Pille (AP-46 5.1). */
export function StatusPill({ status, amGeraet }: { status: SiteDocStatus; amGeraet?: boolean }) {
  const { t } = useTranslation()
  if (amGeraet) return <span className="inline-flex shrink-0 items-center rounded-full border border-dashed px-2 py-0.5 text-xs text-muted-foreground">{t('siteDocs.status.ON_DEVICE')}</span>
  return <span className={`inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium ${KLASSE[status]}`}>{t(`siteDocs.status.${status}`)}</span>
}
